import { useEffect } from 'react';
import { Box } from '@evaneos/b2b-ui';

import { TravelSuiteFooter } from './components/TravelSuiteFooter';
import { TravelSuiteHeader } from './components/TravelSuiteHeader';
import { TravelSuiteHero } from './components/TravelSuiteHero';
import { TravelSuiteTools } from './components/TravelSuiteTools';

export const HomePage = (): JSX.Element => {
    useEffect(() => {
        document.documentElement.lang = 'en';
    }, []);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <TravelSuiteHeader />
            <Box component="main">
                <TravelSuiteHero />
                <TravelSuiteTools />
            </Box>
            <TravelSuiteFooter />
        </Box>
    );
};
